import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { CkeditorPlugin } from '@ckeditor/ckeditor5-vue';
import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import '@/assets/scss/config/minimal/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import accessPlugin from './helpers/access'
import notifier from './helpers/notifier';

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

createApp(App)
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .use(i18n)
    .use(Toast, {
        position: "bottom-right",
        timeout: 5000,
        closeButton: true,
    })
    .use(notifier, { toast: Toast.instance })
    .use(accessPlugin)
    .use(CkeditorPlugin)
    .use(VueSweetalert2)
    .use(vClickOutside).mount('#app');

